import { useEffect, useState } from "react";
import { json, useNavigate, useParams } from "react-router-dom";
import { MapPin, List, CaseUpper } from "lucide-react";
import MapComponent from "../components/MapComponent";
import { Fragment } from "react";

//import poiDataJSON from "./data/point.json";
import config from "./config";
import logo from './data/logoch.png';
import logoa from './data/logoa.png';
import ImageSlider from "./imgslider";
import MHeader from "./header";
import Mfooter from "./footer";
import LineChartComponent from "./Linechart";
import { map } from "leaflet";
const Button = ({ children, onClick }) => (
  <button
    onClick={onClick}
    className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
  >
    {children}
  </button>
);

const groupInfoValForChart = (infoValArray) => {
  if (!infoValArray || !Array.isArray(infoValArray)) {
    return {};
  }
  
  const groupedData = {};

  infoValArray.forEach(item => {
    // Estraiamo la data e il valore, assicurandoci che il valore sia un numero
    const dataKey = item.datainserimento;
    const id = item.id;
    const value = parseFloat(item.valore); 
    const nome = item.nome;

    if (dataKey && !isNaN(value)) {
      if (!groupedData[nome]) {
        groupedData[nome] = [];
      }
      
      // Formattiamo il dato nel formato atteso dal LineChartComponent
      // Usiamo 'data' per l'asse X e 'valore' per l'asse Y
      groupedData[nome].push({ 
        id_infoval: id,
        data: dataKey, 
        valore: value 
      });
    }
  });

  // Ordina i dati di ogni gruppo per data per un grafico corretto
  for (const nome in groupedData) {
    groupedData[nome].sort((a, b) => new Date(a.data) - new Date(b.data));
  }

  return groupedData;
};



export default function App() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [objData, setobjData] = useState([]);
  //const [view, setView] = useState("map");
  const cardColors = ["card-blue", "card-green", "card-yellow", "card-pink", "card-purple"];
  
  const [mostraDiv, setMostraDiv] = useState(false);
  const gestisciClick = () => {
    setMostraDiv(!mostraDiv); // Imposta su false per nasconderli
  };

  useEffect(() => {


    fetch(config.apiUrl + "/getobjinfo/" + id)
      .then((res) => res.json())
      .then((data) => setobjData(data))
      .catch((error) => console.error("Errore nel fetch delle info:", error));

    //setPoiData(poiDataJSON);
  }, [id]);
  const dat=[]

  return (
    <div className="p-4 pb-[520px]">
      <div className="flex justify-between items-center mb-4" >
        <h1 className="text-2xl font-bold"></h1>
        <MHeader />

      </div>


      <ul className="space-y-4">
        {objData.map((poi, idx) => (
          <div>
              {/* poi.layers && poi.layers.length > 0 && */}
            { (
              <div>
                { poi.layers && poi.layers.length > 0 ?

    (<div align="center">

                  <h2><a href={poi.link} target="_blank" rel="noopener noreferrer">{poi.nome}</a></h2>
                  <ImageSlider poi={poi} />
                  <br />{poi.ldescrizione}
                  <br />{poi.indirizzo}
                  <br />
                  <br />
                </div>) : (<h1>{poi.nome}</h1>)
                }
                {/*                 <div className="card">
                  <h3>Risorse Gis:</h3>
                  <ul>
                    {poi.layers.map((layer, i) => (
                      <li key={i}><a href={layer.link} target="_blank" rel="noopener noreferrer">{layer.nome}</a></li>
                    ))}
                  </ul>
                  </div>
 */}          
                {poi.bimobj.map((bo, i) => (


                  <div>
                    <div className={"card " + cardColors[i % 2]}>
                      <h2>{bo.descrizione}</h2><br />
                    </div>

                    <div>
                      <table className="tabella-sottile">
                        <tr>
                          <th>Id</th>
                          <th>Categoria</th>
                        </tr>
                        <tr>
                          <td>
                            {bo.bimid}
                          </td>
                          <td>
                            {bo.categoria}
                          </td>
                        </tr>
                      </table>
                    </div>

                   {/* <div className={"card " + cardColors[i % 2]}>
                      <h3>Altre Risorse:</h3>
                    </div>
                    */}
                    <div>
                        {bo.biminfo.map((bimin, ii) => {
                          
                          // 1. Raggruppa e formatta i dati per il grafico
                          const chartsData = groupInfoValForChart(bimin.infoval);
                          const chartNames = Object.keys(chartsData);
                           
                          return (
                            <Fragment key={bimin.IdBimInfo || ii}>
                              <small><small>*usare per associazione a sensori</small></small>
                              <table className="tabella-sottile">
                                 <tr>
                                  <th>
                                    ID<small>*</small>
                                    </th>
                                  <th>Tipo</th>

                                <th>Descrizione</th>
                                <th>Contenuto</th>
                                <th>Data Aggiornamento</th>
                                </tr>
                              <tr>
                                <td>{bimin.id}</td>
                                <td>{bimin.tipo}</td>
                                <td>{bimin.descrizione}</td>
                                <td>{bimin.contenuto}</td>
                                <td>{bimin.dataaggiornamento}</td>
                               </tr>
                              </table><br/>
                              
                              
                              
                              <table className="tabella-sottile">


                                    {/* ... (Codice per Allegati - infoall) ... */}
                                <tr>
                                  
                                  <th>
                                    Tipo
                                  </th>
                                   <th>
                                    Descrizione
                                  </th>
                                   <th colspan="2">
                                    Link
                                  </th>
                                   
                                  
                                </tr>
                                {bimin.infoall.map((infoall, i) => (
                                  <tr>
                                    <td>
                                      {infoall.tipo}
                                    </td>
                                    <td>
                                      {infoall.descrizione}
                                    </td>
                                    <td colspan="2">
                                      {infoall.tipo==='URL' && (
                                      <a href={infoall.url} target="_blank" ><button>Apri link</button></a>) 
                                      }

                                      { infoall.tipo==='DOC' && ( 
                                      <a href={config.apiUrl+"/scarica-allegato/" + bimin.id +"/"+infoall.locallink} target="_blank"><button>Scarica File</button></a>)
                                      }
                                      { infoall.tipo==='BIM' && ( 
                                        <button onClick={function aa() {navigate("/xktviewer/"+bimin.id +"/"+infoall.locallink+"/"+infoall.descrizione)}}>Visualizza Modello</button>
                                      )}
                                    </td>
                                  </tr>
                                  )
                                )}
                                </table>
                                      { bimin.infoval.length > 0  && (<center><button onClick={gestisciClick}>Nascondi/Visualizza Misurazioni</button></center>)}
                                    {/* Sezione Valori/Misurazioni (infoval) */}
                                    {bimin.infoval.length > 0  && mostraDiv &&(
                                      <div name="mis">
                                        <table className="tabella-sottile">
                                        <tr><td colSpan="4"><b>Valori e misurazioni</b></td></tr>
                                        <tr><th>
                                    ID
                                  </th><th>Nome</th><th>Valore</th><th>Provenienza</th><th>Data Inserimento</th></tr>
                                        {
                                        
                                        bimin.infoval.map((infoval, v) => (
                                          <tr key={v}>
                                            <td>{infoval.id}</td>
                                            <td>{infoval.nome}</td>
                                            <td>{infoval.valore}</td>
                                            <td>{infoval.provenienza}</td>
                                            <td>{infoval.datainserimento}</td>
                                          </tr>

                                        ))}
                                          
                                        </table>
                                      </div>
                                    )}
                                    {/* FINE Sezione Valori/Misurazioni */}
                                  
                           
                             <table className="tabella-sottile">
                              {/* 2. INSERIMENTO DEL GRAFICO QUI, SOTTO LA RIGA DELLA TABELLA */}
                              {/* Solo se ci sono dati raggruppati per il grafico */}
                              {chartNames.length > 0 && (
                                <tr>
                                  <td colSpan="5">
                                    <div style={{ padding: '10px' }}>
                                        {chartNames.map((chartName, cIdx) => (
                                            <div key={cIdx} style={{ marginBottom: '20px' }}>
                                                {/* LineChartComponent riceve i dati raggruppati */}
                                                <LineChartComponent 
                                                    data={chartsData[chartName]} 
                                                    idKey="id_infoval"  // Data Inserimento
                                                    valueKey="valore" // Valore
                                                    title={`Andamento Storico: ${chartName}`}
                                                />
                                                <hr/>
                                            </div>
                                        ))}
                                    </div>
                                  </td>
                                </tr>
                              )}
                              </table> 
                              {/* FINE INSERIMENTO GRAFICO */}
                            </Fragment>
                          );
                        })}
                    </div>
                  </div>

                ))}
              </div>
            )}
          </div>

        ))}
      </ul>
      <Mfooter />
    </div>
  );
}
